<template>
  <section class="box orange left-box-sizing text-left">
    <!-- box header -->
    <div class="header">
      <bbc-select-courses class="mx-2 mx-md-4" />
      <h2>
        Select your courses
      </h2>
    </div>

    <!-- box content -->
    <div class="content" style="min-height: 200px;">
      <div
        class="option"
        v-for="(course, idx) in courses"
        :key="idx"
      >
        <div
          class="input-group"
        >
          <input
            type="radio"
            name="course"
            :id="`course${idx}`"
            v-model="selected"
            class="my-auto"
            style="position: absolute;"
            :value="idx"
          >
          <label :for="`course${idx}`">
            <img
              alt="Thumbnail"
              :src="course.image"
              width="70"
            >
            <b class="ml-2 ml-lg-0 course-name" :title="course.name">
              {{ course.name }}
            </b>
            <div class="price" style="font-size: 14px; display: inline-block; min-width: 64px;">
              <span>&#8377; {{ course.price.toLocaleString() }}/-</span>
            </div>
          </label>
        </div>
      </div>
    </div>

    <!-- box footer -->
    <div class="footer">
      <form v-on:submit.prevent="proceed()" class="px-3 form">
        <input class="mx-sm-auto ml-md-auto mr-md-0" type="submit" value="Next" :disabled="selected===undefined">
      </form>
    </div>
  </section>
</template>

<script>
// svg
import BbcSelectCourses from '@/components/svg/BbcSelectCourses'

export default {
  name: "SelectBox",
  props: ["courses"],
  components: {
    BbcSelectCourses
  },
  data() {
    return {
      selected: undefined,
    }
  },
  methods: {
    proceed() {
      this.$emit('proceed');
    }
  },
  watch: {
    selected: function() {
      this.$emit('select', this.selected);
    }
  }
}
</script>

<style scoped>
  .box > .content {
    height: 256px;
  }
</style>